export default "__VITE_PUBLIC_ASSET__28106c7e__"